var map = {
	"./EAD.webp": 184,
	"./LaBRI.webp": 932,
	"./acm.webp": 4722,
	"./afihm.webp": 1077,
	"./bordeaux-inp.webp": 6122,
	"./bordeaux-tourism.webp": 6623,
	"./cnrs.webp": 4525,
	"./force-dimension-1.webp": 6997,
	"./immersion.webp": 1905,
	"./inria.webp": 4952,
	"./logo-pepr.webp": 409,
	"./sigchi.webp": 9758,
	"./universite_bordeaux.webp": 3459,
	"./vibra-nova.webp": 4467,
	"./ville-de-bordeaux.webp": 3375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8514;